// Auto-detect API base:
//   local dev     → localhost:8787
//   web prod      → same origin (deployed together with backend)
//   extension     → production server (relative URLs don't work in chrome-extension://)
const isLocal = typeof window !== "undefined" && window.location.hostname === "localhost";
const isExtension = BUILD_TARGET !== "web";
export const API = isExtension
  ? "https://lv.aliving.stream"
  : isLocal
    ? "http://localhost:8787"
    : "";
